// extracted by mini-css-extract-plugin
module.exports = {"code":"TFACode_code__C0eH7","codeText":"TFACode_codeText__mMS7p","codeCurrent":"TFACode_codeCurrent__vOmQZ"};